import { KatapultElement, html } from '../../mixins/katapult-element';

class ServiceSlot extends KatapultElement {
  static get template() {
    return html`
      <style>
        :host {
          display: none;
        }
      </style>
      <slot on-slotchange="slotchange"></slot>
    `;
  }
  static get properties() {
    return {
      name: {
        type: String
      }
    };
  }

  disconnectedCallback() {
    // When the element is disconnected, remove the nodes from the service slot.
    if (this._nodes.length == 0) return;
    const slot = this.pageElement.serviceSlot?.(this.name);
    if (!slot) {
      console.error(`No service slot could be found with the name ${this.name}`);
      return;
    }
    this._nodes.forEach((node) => {
      slot.removeChild(node);
    });
  }

  ready() {
    super.ready();

    this._nodes = [];
  }

  slotchange(e) {
    // WARNING: Changing this.name after this may cause elements to be stranded in the service slot.
    if (!this.name) {
      console.error('No service name specified');
      return;
    }
    // Get the slot element.
    const slot = this.pageElement.serviceSlot?.(this.name);
    // Make sure slot exists.
    if (!slot) {
      console.error(`No service slot could be found with the name ${this.name}`);
      return;
    }
    // Loop through the assigned nodes in the slot and move them to the service slot.
    this.$$('slot')
      .assignedNodes()
      .forEach((node) => {
        // Specify certain elements to not move to the service slot.
        if (['DOM-IF', 'DOM-REPEAT'].includes(node.tagName)) return;
        // Store the node in a list of moved nodes.
        this._nodes.push(node);
        // Enter the item's id into the $ lookup.
        if (node.id) this.$[node.id] = node;
        // Move the node to the service slot.
        slot.appendChild(node);
      });
  }
}

window.customElements.define('service-slot', ServiceSlot);
